import React, { Component } from "react";
import Card from "./components/Card";

class App extends Component {
  render() {
    return (
      <div className="App">
        <div className="container">
          <Card />
        </div>
      </div>
    );
  }
}

export default App;
